import { jwtDecode } from 'jwt-decode';

const listeners = new Set();
function addEventListener(listener) {
    listeners.add(listener);
}

function removeEventListener(listener) {
    listeners.delete(listener);
}

// listen to local storage events, and trigger if we see the JWT token change
// this is needed if multiple tabs are open
window.addEventListener('storage', event => {
    if (event?.key === null) {
        // clear() was called
        invokeListeners(null, null, true);
    } else if(event?.key === 'token.jwt') {
        invokeListeners(event?.oldValue, event?.newValue);
    }
});

function invokeListeners(oldValue, newValue, storageCleared) {
    if (!storageCleared) {
        // JWT token can get updated often, but only invoke the listeners if the userid actually changed
        const oldSub = jwtdecode(oldValue)?.sub;
        const newSub = jwtdecode(newValue)?.sub;
        if (oldSub === newSub) return;
    }

    listeners.forEach(l => l({}));
}

function jwtset(token) {
    const prev = localStorage.getItem('token.jwt');
    if (token) {
        localStorage.setItem('token.jwt', token);
    } else {
        localStorage.removeItem('token.jwt');
    }

    // storage listener only triggers for other tabs
    // so notify listeners of login change here
    invokeListeners(prev, token);
}

function jwtget() {
    return localStorage.getItem('token.jwt');
}

function jwtdecode(token) {
    try {
        return jwtDecode(token);
    } catch (e) {
        // missing or invalid key
        return {};
    }
}

// determines if the currently logged user is a contributor
function contributor() {
    return jwtdecode(jwtget())?.contributor === 1;
}

// determines if the currently logged user is a patreon/twitch supporter
function supporter() {
    return jwtdecode(jwtget())?.supporter === 1;
}

// determines if the currently logged user was a previous twitch supporter
function previous() {
    return jwtdecode(jwtget())?.previous === 1;
}

// account for currently logged in user's characters (i.e. not login ID)
function account() {
    return jwtdecode(jwtget())?.account;
}

// currently logged in userid
function sub() {
    return jwtdecode(jwtget())?.sub;
}

const login = {
    jwt: {
        set: jwtset,
        get: jwtget
    },
    addEventListener,
    removeEventListener,
    contributor,
    supporter,
    previous,
    account,
    sub
};
export default login;